import { useMfa } from '@iheartjane/menu';
import { Box, Loading } from '@iheartjane/reefer';
import type { AerosyncWidget } from 'aerosync-web-sdk';
import { useCallback, useEffect, useState } from 'react';
import type { MutableRefObject } from 'react';

import { MultifactorAuthentication } from '@jane/kiosk/components/lib/MultifactorAuthentication/MultifactorAuthentication';
import { useJaneUser } from '@jane/shared/data-access';

interface AeropayScreenProps {
  isLinkingBankAccount: boolean;
  isLoadingWidget: boolean;
  /** New phone entered on the more-info screen; the MFA code is sent here */
  newPhone?: string;
  /**
   * Side-effect run on every successful verification (whether MFA was shown
   * or auto-skipped). Used to fire the deferred jane-user update once MFA has
   * been satisfied.
   */
  onVerified?: () => void;
  widgetRef: MutableRefObject<AerosyncWidget | null>;
}

const WIDGET_CONTAINER_ID = 'aerosync-widget';

export const AeropayScreen = ({
  isLinkingBankAccount,
  isLoadingWidget,
  newPhone,
  onVerified,
  widgetRef,
}: AeropayScreenProps) => {
  const { requiresMfa } = useMfa();
  const [userVerified, setUserVerified] = useState(false);
  const { data: janeUser } = useJaneUser();
  const phoneNumber = newPhone || janeUser?.user?.phone;

  const handleVerifySuccess = useCallback(() => {
    setUserVerified(true);
    onVerified?.();
    widgetRef.current && widgetRef.current.launch();
  }, [onVerified, widgetRef]);

  useEffect(() => {
    if (!isLoadingWidget && !requiresMfa()) {
      handleVerifySuccess();
    }
  }, [isLoadingWidget]);

  return (
    <>
      {isLinkingBankAccount && <Loading />}
      <Box width="100%">
        {!userVerified && requiresMfa() && !isLinkingBankAccount && (
          <MultifactorAuthentication
            onSuccess={handleVerifySuccess}
            phoneNumber={phoneNumber || ''}
          />
        )}

        <div id={WIDGET_CONTAINER_ID}></div>
      </Box>
    </>
  );
};
